export default function home_videos() {
	
  $('.block-videos .owl-carousel').owlCarousel({
    items: 1,
    dotsEach: false,
    dots: false,
    loop: true,
    nav: true,
    autoplay: false,
    smartSpeed: 1000,
    mouseDrag: true,
    touchDrag: true,
    navText: ['<i class="fas fa-chevron-left"></i>','<i class="fas fa-chevron-right"></i>']
  });

  $('.video-list .item a').magnificPopup({
    disableOn: 700,
    type: 'iframe',
    mainClass: 'mfp-fade',
    removalDelay: 160,
    preloader: false,
    fixedContentPos: true,
    closeOnBgClick: false
  });
	
}